import type { IconAssetEnum } from '../Icon';
import type { CarouselButtonType } from './CarouselButton.types';

export const CarouselButtonIconAssetsByType = {
  backward: 'ChevronLeft',
  forward: 'ChevronRight',
} as const satisfies Record<CarouselButtonType, IconAssetEnum>;
